import format from 'date-fns/format';
import defaultDateFormat from 'Common/constants/defaultDateFormat';
import de from 'date-fns/locale/de';

const formatDate = (date, customFormat) =>
    format(date, customFormat ?? defaultDateFormat, { locale: de });

export default formatDate;
